import { Injectable, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
})
export class TranslateConfigService {
    private translate = inject(TranslateService);


    currentLang: string;

    constructor() {
        this.currentLang = localStorage.getItem('lang') || 'es';
    }

    getDefaultLanguage() {
        if (this.currentLang) {
            this.translate.setDefaultLang(this.currentLang);
            localStorage.setItem('lang', this.currentLang);

        } else {
            // localStorage.setItem('lang', this.translate.getBrowserLang());
            // this.currentLang = this.translate.getBrowserLang();

            localStorage.setItem('lang', 'es');
            this.currentLang = 'es';

            this.translate.setDefaultLang(this.currentLang);
        }
        return this.currentLang;
    }

    setLanguage(setLang: string) {
        this.translate.use(setLang);
        localStorage.setItem('lang', setLang);
    }

    getCurrentLang() {
        return localStorage.getItem('lang') || 'es';
    }

}